import BaseForm from '@js/forms/base-form'
import { getDisplayedUrl } from '@js/str-utils'
import { isObject } from '@js/data-utils'

class FormTenantUser extends BaseForm {
  static getDataTemplate () {
    return {
      description: '',
      location: '',
      title: '',
      links: [
        {
          name: '',
          url: '',
        },
      ],
    };
  }
  constructor () {
    super();
    this.params.id = null;
  }
  getPutPayload () {
    return {
      description: this.data.description,
      location: this.data.location,
      title: this.data.title,
      links: this.data.links
        .reduce((result, elem, displayOrder) => {
          if (elem.url.trim().length === 0) {
            return result;
          }
          result.push({
            displayOrder: displayOrder,
            name: getDisplayedUrl(elem.url.trim()),
            url: elem.url.trim(),
          });
          return result;
        }, []),
    };
  }
  extendLinks () {
    this.data.links.push({
      name: '',
      url: '',
    });
  }
  isDifferentFrom (tenantUser) {
    return (
      this.data.description !== tenantUser.description ||
      this.data.location !== tenantUser.location ||
      this.data.title !== tenantUser.title ||
      tenantUser.links.length !== this.data.links.filter(
        elem => elem.url.length > 0
      ).length ||
      tenantUser.links.reduce((result, initLink, index) => {
        return (
          result ||
          initLink.name !== this.data.links[index].name ||
          initLink.url !== this.data.links[index].url
        );
      }, false)
    );
  }
  set (tenantUser) {
    if (!isObject(tenantUser)) {
      this.clear();
      return;
    }

    this.params.id = tenantUser.id;
    this.data.description = tenantUser.description;
    this.data.location = tenantUser.location;
    this.data.title = tenantUser.title;
    this.data.links = !tenantUser.links || tenantUser.links.length === 0
      ? [
          {
            name: '',
            url: '',
          }
        ]
     : tenantUser.links.map(obj => Object.assign({}, obj));
  }
}

export {
  FormTenantUser,
};
